import { render } from "./MailRegisterComplete.vue?vue&type=template&id=304f28da&scoped=true"
import script from "./MailRegisterComplete.vue?vue&type=script&lang=js"
export * from "./MailRegisterComplete.vue?vue&type=script&lang=js"

import "./MailRegisterComplete.vue?vue&type=style&index=0&id=304f28da&lang=scss&scoped=true"

import exportComponent from "/var/www/html/app_player/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-304f28da"]])

export default __exports__